document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.c-faq__item details');

    faqItems.forEach((item) => {
        item.addEventListener('toggle', (event) => {
            if (item.open) {
                const answer = item.querySelector('.c-faq__answer');
                const height = answer.scrollHeight;

                answer.style.height = '0';
                answer.style.overflow = 'hidden';
                answer.style.transition = `height 0.3s ease-in-out`;

                setTimeout(() => {
                    answer.style.height = `${height}px`;
                }, 0);

                answer.addEventListener('transitionend', () => {
                    if (item.open) {
                        answer.style.height = 'auto';
                    }
                }, { once: true });
            } else {
                const answer = item.querySelector('.c-faq__answer');
                const height = answer.scrollHeight;

                answer.style.height = `${height}px`;
                answer.style.overflow = 'hidden';
                answer.style.transition = `height 0.3s ease-in-out`;

                setTimeout(() => {
                    answer.style.height = '0';
                }, 0);
            }
        });
    });
});
